import React, { ChangeEvent, FC } from 'react'
import classNames from 'classnames'
import styles from 'styles/components/form.module.scss'
import { PointCardType } from 'types/pointCard'
import { POINT_CARD_COLORS } from 'constants/pointCard'

type Props = {
  color: PointCardType['color']
  handleColor: (e: ChangeEvent<HTMLInputElement>) => void
}

const PointCardColorForm: FC<Props> = (props) => {
  const { color, handleColor } = props
  return (
    <div className={classNames(styles.pointCardColorWrapper)}>
      {POINT_CARD_COLORS.map((hex) => (
        <div className={classNames(styles.pointCardColorBackground)} key={hex}>
          <label
            className={classNames(styles.pointCardColor, {
              [styles.pointCardColor_active]: color === hex,
            })}
            htmlFor={hex}
            style={{ backgroundColor: hex }}
          >
            <input checked={color === hex} id={hex} onChange={handleColor} type={'radio'} value={hex} />
          </label>
        </div>
      ))}
    </div>
  )
}

export default PointCardColorForm
